import React from 'react';
import '../../TasksPage.css';

function TaskHistoryList({ history, onLoadMore, hasMore }) {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const today = new Date();
    const isToday = date.toDateString() === today.toDateString();
    
    if (isToday) {
      return 'Today, ' + date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
    }
    
    return date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric', 
      hour: 'numeric', 
      minute: '2-digit' 
    });
  };

  const getStageColor = (stage) => {
    const colors = {
      'lead': '#3b82f6',
      'customer': '#10b981',
      'marketer': '#f59e0b',
      'leader': '#8b5cf6'
    };
    return colors[stage] || '#6b7280';
  };

  const getStageIcon = (stage) => {
    const icons = {
      'lead': '👥',
      'customer': '🛒',
      'marketer': '🚀',
      'leader': '👑'
    };
    return icons[stage] || '📋';
  };

  return (
    <div className="section history-section">
      <h2>Task History ({history.length} shown)</h2>
      
      {history.length > 0 ? (
        <>
          <div className="history-table">
            <div className="history-header">
              <div className="col-date">Date/Time</div>
              <div className="col-task">Task</div>
              <div className="col-contact">Contact</div>
              <div className="col-stage">Stage</div>
              <div className="col-time">Time</div>
              <div className="col-status">Status</div>
            </div>
            {history.map((item, index) => (
              <div key={index} className="history-row">
                <div className="col-date">{formatDate(item.completed_at)}</div>
                <div className="col-task">{item.task_name}</div>
                <div className="col-contact">{item.first_name} {item.last_name}</div>
                <div className="col-stage">
                  <span 
                    className="stage-badge" 
                    style={{ backgroundColor: getStageColor(item.contact_stage) }}
                  >
                    {getStageIcon(item.contact_stage)} {item.contact_stage}
                  </span>
                </div>
                <div className="col-time">
                  {item.completed_before_generation ? (
                    <span className="proactive-badge" title="Completed proactively before it appeared as a task">
                      ✓ {item.formatted_time || '-'}
                    </span>
                  ) : (
                    item.formatted_time || '-'
                  )}
                </div>
                <div className="col-status">
                  <span className={`status-badge ${item.action}`}>
                    {item.action}
                  </span>
                </div>
              </div>
            ))}
          </div>
          
          {hasMore && (
            <button className="load-more-btn" onClick={onLoadMore}>
              Load More Tasks
            </button>
          )}
        </>
      ) : (
        <div className="empty-state">No task history found for the selected filters</div>
      )}
    </div>
  );
}

export default TaskHistoryList;
